// extracted by mini-css-extract-plugin
export default {"root":"style_root__9YcpA","heading":"style_heading__OhoKX","description":"style_description__aG7Ka"};